<template>
  <div class="Album">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="val in data">
        <img @click="showIt(val)" class="bannerPic" :src="val" />
      </div>
    </div>
    <template v-if="data.length > 4">
      <div class="swiper-button-next" @click="swiper.slidePrev()">
        <i class="el-icon-arrow-left"></i>
      </div>
      <div class="swiper-button-prev" @click="swiper.slideNext()">
        <i class="el-icon-arrow-right"></i>
      </div>
    </template>
  </div>
</template>

<script>
import Swiper from "swiper";
export default {
  name: "Album",
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  watch: {
    data() {
      setTimeout(() => {
        this.swiper = new Swiper(".Album", {
          slidesPerView: 4,
          spaceBetween: 10,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        });
      });
    },
  },
  data() {
    return {
      swiper: {},
    };
  },
  created() {
    // 若img标签使用的是异步图片数据，需要在加载数据之后，加一句：
    // this.$previewRefresh();
    // 这样刷新之后，vue-photo-preview预览效果才起效
  },
  methods: {
    showIt(url) {
      this.$emit("showIt", url);
    },
  },
};
</script>

<style lang="less" scoped>
.Album {
  width: 100%;
  height: 100%;
  position: relative;
  .bannerPic {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .swiper-button-next,
  .swiper-button-prev {
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ffffff;
    text-align: center;
    line-height: 40px;
    color: #000;
    font-size: 12px;
    font-weight: bolder;
    top: 47px;
    z-index: 9;
    opacity: 0.8;
    cursor: pointer;
    &:hover {
      opacity: 1;
    }
  }
  .swiper-button-next {
    left: 10px;
  }
  .swiper-button-prev {
    right: 10px;
  }
}
</style>
